'use strict';

var _regeneratorRuntime = require("/Users/sekhuat/ionicApp/JustShootIt/App/node_modules/@babel/runtime/regenerator");
var _asyncToGenerator = require("/Users/sekhuat/ionicApp/JustShootIt/App/node_modules/@babel/runtime/helpers/asyncToGenerator");
var axios = require('axios').default;
var baseURL = 'http://localhost:1337';
module.exports = {
  // Storage delegation methods
  setToken: undefined,
  getToken: undefined,
  initStrapi: function initStrapi(url, tokenGetter, tokenSetter) {
    baseURL = url;
    this.getToken = tokenGetter;
    this.setToken = tokenSetter;
  },
  authenticate: function authenticate(cridential) {
    var _this = this;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var response;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return axios.post("".concat(baseURL, "/auth/local"), cridential);
            case 3:
              response = _context.sent;
              // Invoke the setToken storage delegation method only when it is defined.
              _this.setToken && _this.setToken(response.data);
              return _context.abrupt("return", response);
            case 8:
              _context.prev = 8;
              _context.t0 = _context["catch"](0);
              // Invoke the setToken storage delegation method only when it is defined.
              _this.setToken && _this.setToken({
                jwt: '',
                user: null,
                refresh_token: ''
              });
              return _context.abrupt("return", _context.t0);
            case 12:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 8]]);
    }))();
  },
  authProviderLoginUrl: function authProviderLoginUrl(provider) {
    return "".concat(baseURL, "/connect/").concat(provider.toLowerCase());
  },
  authProviderLoginCallback: function authProviderLoginCallback(provider, tokens) {
    var _this2 = this;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var response;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 3;
              return axios.get("".concat(baseURL, "/auth/").concat(provider.toLowerCase(), "/callback").concat(tokens));
            case 3:
              response = _context2.sent;
              if (response && response.data && _this2.setToken) {
                _this2.setToken(response.data);
              }
              return _context2.abrupt("return", response);
            case 8:
              _context2.prev = 8;
              _context2.t0 = _context2["catch"](0);
              return _context2.abrupt("return", _context2.t0);
            case 11:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[0, 8]]);
    }))();
  },
  get: function get(method, headers) {
    var _this3 = this;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
      var token, response;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              token = _this3.getToken ? _this3.getToken() : null;
              if (headers === null || headers === undefined) {
                headers = {};
              }
              delete headers['Authorization']; // Remove the Authorization header is specified in the headers param.
              if (token !== null) headers.Authorization = 'Bearer ' + token; // Set the Authorization header to the token returned by the getToken method
              _context3.next = 7;
              return axios.get("".concat(baseURL, "/").concat(method), {
                headers: headers
              });
            case 7:
              response = _context3.sent;
              return _context3.abrupt("return", response);
            case 11:
              _context3.prev = 11;
              _context3.t0 = _context3["catch"](0);
              return _context3.abrupt("return", _context3.t0);
            case 14:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[0, 11]]);
    }))();
  },
  post: function post(method, body, headers) {
    var _arguments = arguments,
      _this4 = this;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
      var onUploadProgress, token, response;
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              onUploadProgress = _arguments.length > 3 && _arguments[3] !== undefined ? _arguments[3] : undefined;
              _context4.prev = 1;
              token = _this4.getToken ? _this4.getToken() : null;
              if (headers === null || headers === undefined) {
                headers = {};
              }
              delete headers['Authorization']; // Remove the Authorization header is specified in the headers param.
              if (token !== null) headers.Authorization = 'Bearer ' + token; // Set the Authorization header to the token returned by the getToken method
              _context4.next = 8;
              return axios.post("".concat(baseURL, "/").concat(method), body, {
                headers: headers,
                onUploadProgress: onUploadProgress
              });
            case 8:
              response = _context4.sent;
              return _context4.abrupt("return", response);
            case 12:
              _context4.prev = 12;
              _context4.t0 = _context4["catch"](1);
              return _context4.abrupt("return", _context4.t0);
            case 15:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, null, [[1, 12]]);
    }))();
  },
  put: function put(method, body, headers) {
    var _arguments2 = arguments,
      _this5 = this;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
      var onUploadProgress, token, response;
      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              onUploadProgress = _arguments2.length > 3 && _arguments2[3] !== undefined ? _arguments2[3] : undefined;
              _context5.prev = 1;
              token = _this5.getToken ? _this5.getToken() : null;
              if (headers === null || headers === undefined) {
                headers = {};
              }
              delete headers['Authorization']; // Remove the Authorization header is specified in the headers param.
              if (token !== null) headers.Authorization = 'Bearer ' + token; // Set the Authorization header to the token returned by the getToken method
              _context5.next = 8;
              return axios.put("".concat(baseURL, "/").concat(method), body, {
                headers: headers,
                onUploadProgress: onUploadProgress
              });
            case 8:
              response = _context5.sent;
              return _context5.abrupt("return", response);
            case 12:
              _context5.prev = 12;
              _context5.t0 = _context5["catch"](1);
              return _context5.abrupt("return", _context5.t0);
            case 15:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, null, [[1, 12]]);
    }))();
  },
  patch: function patch(method, body, headers) {
    var _this6 = this;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
      var token, response;
      return _regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _context6.prev = 0;
              token = _this6.getToken ? _this6.getToken() : null;
              if (headers === null || headers === undefined) {
                headers = {};
              }
              delete headers['Authorization']; // Remove the Authorization header is specified in the headers param.
              if (token !== null) headers.Authorization = 'Bearer ' + token; // Set the Authorization header to the token returned by the getToken method
              _context6.next = 7;
              return axios.patch("".concat(baseURL, "/").concat(method), body, {
                headers: headers
              });
            case 7:
              response = _context6.sent;
              return _context6.abrupt("return", response);
            case 11:
              _context6.prev = 11;
              _context6.t0 = _context6["catch"](0);
              return _context6.abrupt("return", _context6.t0);
            case 14:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6, null, [[0, 11]]);
    }))();
  },
  delete: function _delete(method, headers) {
    var _this7 = this;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
      var token, response;
      return _regeneratorRuntime.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              _context7.prev = 0;
              token = _this7.getToken ? _this7.getToken() : null;
              if (headers === null || headers === undefined) {
                headers = {};
              }
              delete headers['Authorization']; // Remove the Authorization header is specified in the headers param.
              if (token !== null) headers.Authorization = 'Bearer ' + token; // Set the Authorization header to the token returned by the getToken method
              _context7.next = 7;
              return axios.delete("".concat(baseURL, "/").concat(method), {
                headers: headers
              });
            case 7:
              response = _context7.sent;
              return _context7.abrupt("return", response);
            case 11:
              _context7.prev = 11;
              _context7.t0 = _context7["catch"](0);
              return _context7.abrupt("return", _context7.t0);
            case 14:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7, null, [[0, 11]]);
    }))();
  }
};